module.exports = __webpack_public_path__ + "img/error-illustration.81e77e75.svg";